const getClassList = levelObj => levelObj.classList ? levelObj.classList: [""]
const getCardId = (cardIdType, index) => `${cardIdType}_${index}`

const getFormattedText = (text, isBold) => {
    let startAttr = ``
    let endAttr = ``
    if (isBold) {
        startAttr = "<strong>"
        endAttr = "</strong>"
    }
    return `${startAttr} ${text} ${endAttr}`
}

const createAndAddGenericElement = (arrClassList, childElement, parentElement, textContent, elementType, isBold=undefined) => {
    const genericElement = document.createElement(elementType)
    for (let i = 0; i < arrClassList.length; ++i) {
        if(arrClassList[i]) genericElement.classList.add(arrClassList[i])
    }
    if(childElement) genericElement.appendChild(childElement)
    if(textContent) genericElement.innerHTML = getFormattedText(textContent, isBold)
    if(parentElement) parentElement.appendChild(genericElement)  
    return genericElement
}

const createImageElement = (imageWrapperData, parentElement, isCreateWrapper) => {
    let imageWrapperDiv = parentElement
    if (isCreateWrapper) {
        imageWrapperDiv = createAndAddGenericElement(getClassList(imageWrapperData), "", "", "", imageWrapperData.element)
    }
    const imageDiv = createAndAddGenericElement(getClassList(imageWrapperData.image), "", "", "", imageWrapperData.image.element)
    
    // Convert relative paths to full URLs for deployment compatibility
    let imageSrc = imageWrapperData.image.image
    if (imageSrc && imageSrc.startsWith('/')) {
        // If it's a relative path starting with /, make it a full URL
        imageSrc = window.location.origin + imageSrc
    }
    
    imageDiv.setAttribute('src', imageSrc)
    imageDiv.setAttribute('alt', imageWrapperData.image.altText)
    imageWrapperDiv.appendChild(imageDiv)
    if (parentElement !== imageWrapperDiv) parentElement.appendChild(imageWrapperDiv)
}

const createCenteredUnderlinedText = (text, elementTag, parentDiv) => {
    const headingText = createAndAddGenericElement(["text-center", "mt-5", "mb-5", "custom-underline"], "", "", text, elementTag)
    createAndAddGenericElement(["boxUnderline"], headingText, parentDiv, "", "div")
}

const createBannerComponent = (text, elementTag, parentDiv) => {
    const displayText = createAndAddGenericElement(["contact-heading", "text-center", "mb-4"], "", parentDiv, text, elementTag)
    createAndAddGenericElement(["feature-heading"], displayText, parentDiv, "", "div")
}

export { createAndAddGenericElement, getFormattedText, getClassList, getCardId, createImageElement, createCenteredUnderlinedText, createBannerComponent }

